var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditMo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.76359 8.37387L7.2637 3.87377L5.12623 1.7363L0.626131 6.2364C0.564178 6.29843 0.52017 6.37608 0.498774 6.46109L0 9L2.53842 8.50123C2.62365 8.47992 2.70161 8.43585 2.76359 8.37387ZM8.71644 2.42103C8.898 2.23941 9 1.99311 9 1.7363C9 1.47949 8.898 1.2332 8.71644 1.05158L7.94842 0.283562C7.7668 0.101997 7.52051 0 7.2637 0C7.00689 0 6.76059 0.101997 6.57897 0.283562L5.81096 1.05158L7.94842 3.18904L8.71644 2.42103Z",
    fill: "#214ba5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditMo);
export default __webpack_public_path__ + "static/media/editMO.024fbd10fb5c61913e48a86f36e34a8d.svg";
export { ForwardRef as ReactComponent };